import React from 'react';
import './style.scss'
import { useStore } from "../../store/store"
import { t } from '@web-solutions/module-localization';

const Footer = () => {
    const setPage = useStore((state) => state.setPage);

    return (
      <div className={'container'}>
        <div className="contact-us">{t('onboarding.personalPlan.footer.contactUs')}</div>
        <div className="address">{t('onboarding.personalPlan.footer.adress')}</div>
        <div className="links">
          <span className='links_top'>
            <a onClick={() => setPage("privacy-policy")}>{t('onboarding.personalPlan.footer.privacy')}</a>
            <a onClick={() => setPage("terms-of-use")}>{t('onboarding.personalPlan.footer.term')}</a>
          </span>
        </div>
      </div>
    );
}

export default Footer;
